{
  "title": "Mon profil",
  "subtitle": "Votre nom, votre langue, votre mot de passe et vos e-mails d'alerte.",
  "saved": "Profil enregistré",
  "personal": {
    "title": "Vous"
  },
  "role": "Rôle",
  "workplaces": "Peut travailler à",
  "lastSignIn": "Dernière connexion",
  "allLocations": "Tous les emplacements",
  "languageHint": "L'interface passe dans cette langue sur tous les appareils que vous utilisez.",
  "fields": {
    "fullName": "Nom complet",
    "language": "Langue"
  },
  "password": {
    "title": "Mot de passe",
    "subtitle": "Le changer vous déconnecte de vos autres appareils."
  },
  "notifications": {
    "title": "Notifications d'alerte",
    "subtitle": "Les nouvelles alertes apparaissent toujours sur la cloche. Choisissez ce que vous recevez aussi par e-mail.",
    "email": "E-mail pour chaque alerte",
    "emailText": "Un court e-mail quand une alerte concerne vos emplacements.",
    "digest": "Résumé quotidien par e-mail",
    "digestText": "Une fois par jour, les alertes encore ouvertes.",
    "noEmail": "Vous n'avez pas encore d'adresse e-mail. Demandez à un administrateur de l'ajouter à votre compte.",
    "saved": "Réglages de notification enregistrés"
  }
}
